// extracted by mini-css-extract-plugin
export var actionButton = "_hv-0";
export var actionMenuContainer = "_hv-i";
export var bubble = "_hv-2";
export var bubbleActionMenu = "_hv-j";
export var bubbleContext = "_hv-6";
export var bubbleItems = "_hv-7";
export var customer = "_hv-3";
export var divider = "_hv-8";
export var fileList = "_hv-9";
export var hiddenComment = "_hv-o";
export var infoAbove = "_hv-a";
export var internal = "_hv-4";
export var lightActionButton = "_hv-1";
export var link = "_hv-b";
export var merchant = "_hv-5";
export var message = "_hv-c";
export var profilePicture = "_hv-e";
export var quillToolbarContainer = "_hv-f";
export var senderDate = "_hv-g";
export var senderDateCustomer = "_hv-h";
export var senderName = "_hv-d";
export var time = "_hv-k";
export var uploadedImage = "_hv-l";
export var username = "_hv-m";
export var xsmall = "_hv-n";